module.exports = __webpack_public_path__ + "img/car-gray.0a7297ab.svg";